export const backendUrl = "https://localhost:44323/";

export const headers = {
    'mode': 'cors',
    'Access-Control-Allow-Headers': 'X-PINGOTHER, Content-Type',
    'Access-Control-Allow-Origin': "*",
    "Content-Type": "application/json",
};